import { render } from "./my-form.vue?vue&type=template&id=66c2bee8"
import script from "./my-form.vue?vue&type=script&lang=js"
export * from "./my-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__